import '.j{display:flex;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.k{justify-content:center;}.ssr-plugin'
import '.v{flex-direction:column;}.ssr-plugin'
import '.az{background-color:var(--shades-beige-100);}.ssr-plugin'
import '.b8{min-height:calc(100vh - 12rem);}.ssr-plugin'
import '.ae{align-items:stretch;}.ssr-plugin'
import '.b9{margin-top:2rem;}.ssr-plugin'
import '.av{margin-bottom:5rem;}.ssr-plugin'
import '.au{max-width:77.5rem;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { ClientOnly, Head } from '@based/sdk'

export const DashboardPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <Head>
        <title>CrowdBuilding - dashboard</title>
      </Head>
      <div className="j r k v az"
      >
        <DashboardNavBar />
        <div className="b8 j v ae b9 av au"
          style={{
            gap: gap,
            width: isMobile ? '100%' : '85%', // 12rem is padding + navbar height
            paddingInline: isMobile ? '1rem' : 0,}}
        >
          {children}
        </div>
      </div>
    </ClientOnly>
  )
}
